'use client'

import React from 'react'
import { Box, Flex } from '@chakra-ui/react'

import { ImageType } from 'appTypes/items'
import { useSlider } from 'utils/useSlider'

import { ProductImageWrapper, Slide, SlidePreview, SliderBullet, StyledSlider } from './styles'

type Props = {
  images: ImageType[] | null | undefined
}

const ProductImagesSlider = ({ images }: Props): JSX.Element | null => {
  if (!images) {
    return null
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { touchHandlers, selectedSlide, handleSlideSelect } = useSlider({
    slides: images,
  })

  return (
    <Box>
      <ProductImageWrapper>
        <StyledSlider {...touchHandlers}>
          {images.map((image, index: number) => (
            <Slide
              key={index}
              isActive={selectedSlide === index}
              isPrevious={selectedSlide - 1 >= index}
              isNext={selectedSlide + 1 <= index}
            >
              <img src={image.url} alt={image.productName} />
            </Slide>
          ))}
          {images.length > 1 && (
            <Flex
              position="absolute"
              bottom="12px"
              left="50%"
              transform="translateX(-50%)"
              display={{ base: 'flex', lg: 'none' }}
            >
              {images.map((_, index: number) => (
                <SliderBullet key={index} isActive={selectedSlide === index} onClick={() => handleSlideSelect(index)} />
              ))}
            </Flex>
          )}
        </StyledSlider>
      </ProductImageWrapper>
      {images.length > 1 && (
        <Box display={{ base: 'none', lg: 'grid' }} gridTemplateColumns="repeat(4, 1fr)" gridGap="20px">
          {images.map((image, index: number) => (
            <SlidePreview key={index} onClick={() => handleSlideSelect(index)}>
              <img src={image.url} alt="" />
            </SlidePreview>
          ))}
        </Box>
      )}
    </Box>
  )
}

export default ProductImagesSlider
